import { typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import IconButton from '../../core/components/IconButton/component.js';
import { Tag } from '../../core/components/Tag/component.js';
import { TagSize, TagVariant } from '../../core/components/Tag/types.js';
var AttentionGrabber = function AttentionGrabber(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'generic' : _ref$type,
    grabberClick = _ref.grabberClick,
    label = _ref.label,
    icon = _ref.icon,
    iconClick = _ref.iconClick,
    rightIcon = _ref.rightIcon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? TagSize.MEDIUM : _ref$size,
    leftIconClick = _ref.leftIconClick,
    isClosable = _ref.isClosable;
  var colorScheme = type === 'generic' || type === 'outline' ? 'neutral' : type;
  var getIconName = function getIconName(icon) {
    return typeof icon === 'string' ? icon : icon === null || icon === void 0 ? void 0 : icon.icon;
  };
  var getAriaLabel = function getAriaLabel(icon) {
    return _typeof(icon) === 'object' && icon !== null && icon !== void 0 && icon.ariaLabel ? icon.ariaLabel : 'action-button';
  };
  var leftIconButton = leftIconClick && icon ? /*#__PURE__*/React.createElement(IconButton, {
    icon: {
      iconName: getIconName(icon)
    },
    ariaLabel: getAriaLabel(icon),
    onClick: leftIconClick,
    variant: "link",
    colorScheme: colorScheme,
    size: "xs",
    minW: "unset"
  }) : null;
  var rightIconButton = iconClick && rightIcon ? /*#__PURE__*/React.createElement(IconButton, {
    icon: {
      iconName: getIconName(rightIcon)
    },
    ariaLabel: getAriaLabel(rightIcon),
    onClick: iconClick,
    variant: "link",
    colorScheme: colorScheme,
    size: "xs",
    minW: "unset"
  }) : null;

  // If icons are non-clickable, prepare icon props for Core.Tag
  var leftIconProp = leftIconClick ? undefined : icon ? {
    iconName: getIconName(icon)
  } : undefined;
  var rightIconProp = iconClick ? undefined : rightIcon ? {
    iconName: getIconName(rightIcon)
  } : undefined;
  return /*#__PURE__*/React.createElement(Tag, {
    colorScheme: colorScheme,
    variant: type === 'outline' ? TagVariant.outline : TagVariant.subtle,
    onClick: grabberClick,
    size: size,
    tagLabel: !(leftIconButton && rightIconButton) ? label : undefined,
    isClosable: isClosable,
    leftIcon: leftIconProp,
    rightIcon: rightIconProp
  }, leftIconButton, leftIconButton && rightIconButton && label, rightIconButton);
};
AttentionGrabber.displayName = "AttentionGrabber";
AttentionGrabber.displayName = 'AttentionGrabber';
export { AttentionGrabber };